import React from 'react';
import styles from './index.module.scss';

const Credit = ({ className }) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='44.434'
        height='44'
        viewBox='0 0 44.434 44'
        className={className}
    >
        <g transform='translate(0 38.956)'>
            <path
                d='M41.126-38.956H3.308A3.308,3.308,0,0,0,0-35.648V-6.509A3.308,3.308,0,0,0,3.308-3.2h8.933a9.992,9.992,0,0,1,9.98-9.98A9.992,9.992,0,0,1,32.2-3.2h8.924a3.308,3.308,0,0,0,3.308-3.308V-35.648A3.308,3.308,0,0,0,41.126-38.956Z'
                className={styles.light}
            />
            <circle
                cx='8.245'
                cy='8.245'
                r='8.245'
                transform='translate(13.977 -11.445)'
                className={styles.light}
            />
            <g transform='translate(3.124 -33.328)'>
                <path
                    d='M207.344,321.452h-3.127v2.975a.942.942,0,0,1-1.883,0v-2.975H199.2a.942.942,0,0,1,0-1.883h3.132v-3.284a.942.942,0,0,1,1.883,0v3.284h3.127a.942.942,0,0,1,0,1.883Z'
                    transform='translate(-184.183 -290.229)'
                    className={styles.dark}
                />
                <g transform='translate(0 0)'>
                    <rect
                        width='7.42'
                        height='0.515'
                        transform='translate(0 2.704)'
                        className={styles.dark}
                    />
                    <rect
                        width='7.42'
                        height='0.515'
                        transform='translate(0 3.629)'
                        className={styles.dark}
                    />
                    <path
                        d='M36.232,78.383a1.6,1.6,0,0,0,.169.515h7.041a1.6,1.6,0,0,0,.169-.515Z'
                        transform='translate(-36.212 -73.828)'
                        className={styles.dark}
                    />
                    <rect
                        width='7.42'
                        height='0.515'
                        transform='translate(0 1.778)'
                        className={styles.dark}
                    />
                    <path
                        d='M36.4,35.717a1.6,1.6,0,0,0-.169.515h7.38a1.6,1.6,0,0,0-.169-.515Z'
                        transform='translate(-36.212 -34.865)'
                        className={styles.dark}
                    />
                    <path
                        d='M41.81,89.05a1.6,1.6,0,0,0,1.105.441h4.2a1.6,1.6,0,0,0,1.105-.441Z'
                        transform='translate(-41.306 -83.569)'
                        className={styles.dark}
                    />
                    <path
                        d='M48.222,26.336a1.6,1.6,0,0,0-1.105-.441h-4.2a1.6,1.6,0,0,0-1.105.441Z'
                        transform='translate(-41.306 -25.895)'
                        className={styles.dark}
                    />
                </g>
                <g transform='translate(28.245)'>
                    <path
                        d='M364.836,28.856a3.557,3.557,0,0,1,1.081-2.555,2.961,2.961,0,1,0,0,5.111A3.558,3.558,0,0,1,364.836,28.856Z'
                        transform='translate(-361.46 -25.895)'
                        className={styles.dark}
                    />
                    <circle
                        cx='2.961'
                        cy='2.961'
                        r='2.961'
                        transform='translate(3.983)'
                        className={styles.dark}
                    />
                </g>
                <rect
                    width='29.35'
                    height='1.736'
                    rx='0.868'
                    transform='translate(0.347 14.287)'
                    className={styles.dark}
                />
                <rect
                    width='10.505'
                    height='1.736'
                    rx='0.868'
                    transform='translate(0.347 18.018)'
                    className={styles.dark}
                />
            </g>
        </g>
    </svg>
);

export default Credit;
